import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import styles from './PluginsPage.module.css';

const DEFAULT_YT_VIDEO_ID = 'dQw4w9WgXcQ';

interface ReleaseLinks {
  windows: string;
  mac: string;
  version: string;
}

const PluginsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [release, setRelease] = useState<ReleaseLinks>({
    windows: `${API_BASE_URL}/api/launcher/download/windows`,
    mac: `${API_BASE_URL}/api/launcher/download/mac`,
    version: '',
  });
  const [loading, setLoading] = useState(true);
  const [ytVideoId, setYtVideoId] = useState<string>(DEFAULT_YT_VIDEO_ID);

  useEffect(() => {
    if (searchParams.get('plans') === 'true') {
      // ...
    }
  }, [searchParams]);

  // Busca o vídeo configurado no painel
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/config`)
      .then(res => res.ok ? res.json() : Promise.reject())
      .then((data: { plugins_video_id?: string }) => {
        if (data.plugins_video_id) setYtVideoId(data.plugins_video_id);
      })
      .catch(() => { /* mantém default */ });
  }, []);

  // Fetch version info from backend
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/launcher/version`)
      .then(res => res.ok ? res.json() : Promise.reject())
      .then((data: { version: string }) => {
        setRelease({
          windows: `${API_BASE_URL}/api/launcher/download/windows`,
          mac: `${API_BASE_URL}/api/launcher/download/mac`,
          version: data.version ? `v${data.version}` : '',
        });
      })
      .catch(() => {
        // fallback - keep proxy links, just no version badge
      })
      .finally(() => setLoading(false));
  }, []);

  const handleDownload = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <main className={styles.wrapper}>
      <div className={styles.card}>

        {/* Lado esquerdo: Player do YouTube */}
        <div className={styles.videoSide}>
          <iframe
            className={styles.ytPlayer}
            src={`https://www.youtube-nocookie.com/embed/${ytVideoId}?rel=0`}
            title="ARC Launcher Demo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        {/* Lado direito: Conteúdo */}
        <div className={styles.contentSide}>
          <div className={styles.topLogoContainer}>
            <img src="/Estrelamaior.png" className={styles.topLogo} alt="Logo" />
          </div>
          
          <h1 className={styles.title}>
            O NOVO HUB DOS PLUGINS
          </h1>
          <p className={styles.description}>
            O ecossistema oficial da Clydes. Adquira <strong>plugins de áudio</strong>, 
            serviços especializados de produção musical e ferramentas de <strong>automação</strong> para 
            otimizar seu workflow. Além disso, acompanhe nossos eventos e notícias 
            em primeira mão pelo ARC Launcher.
          </p>

          <div className={styles.buttonGroup}>
            <button 
              onClick={() => handleDownload(release.windows)} 
              className={styles.downloadButton}
              disabled={loading || !release.windows}
            >
              <span className="material-symbols-outlined notranslate" translate="no">desktop_windows</span>
              {loading ? 'Carregando...' : 'Windows'}
            </button>
            <button 
              onClick={() => handleDownload(release.mac)} 
              className={styles.downloadButton}
              disabled={loading || !release.mac}
            >
              <span className="material-symbols-outlined notranslate" translate="no">laptop_mac</span>
              {loading ? 'Carregando...' : 'macOS'}
            </button>
          </div>
          
          <div className={styles.badges}>
            <span className={styles.badge}>{release.version || 'BETA'}</span>
          </div>
        </div>

      </div>
    </main>
  );
};

export default PluginsPage;